import generateUuid from "src/app/libs/generateUuid";
import { generateRankString } from "src/utils/rankStrings";
import { isFacebookNumericUsername, SocialProvider } from "src/types";

const generateSocialProfiles = (socialProviders) =>
  Object.keys(socialProviders).map((key) => {
    const { socialProvider, socialUsername, socialProfileUrl } =
      socialProviders[key];
    return {
      socialProvider,
      socialUsername,
      socialUrl: socialProfileUrl,
    };
  });

const generateSelectedInfluencersWithSocialProfiles = (
  selectedInfluencersUrls,
  searchAudienceResult,
) =>
  selectedInfluencersUrls.map((url) => {
    const foundInfluencerData = searchAudienceResult.find(
      (result) => result.socialProfileUrl || result.profileUrl === url,
    );
    if (foundInfluencerData) {
      return {
        name:
          foundInfluencerData.socialUsername || foundInfluencerData.username,
        socialProfiles: generateSocialProfiles(
          foundInfluencerData.socialProviders,
        ),
        displayName: foundInfluencerData?.name,
      };
    }
    return url;
  });

const generateSelectedInfluencersPayload = (
  selectedInfluencersUrls,
  searchAudienceResult,
) =>
  generateSelectedInfluencersWithSocialProfiles(
    selectedInfluencersUrls,
    searchAudienceResult,
  ).map((creator) => {
    const isFacebookNumericName =
      creator.socialProfiles &&
      creator.socialProfiles[0].socialProvider === SocialProvider.Facebook &&
      isFacebookNumericUsername(creator.name);

    if (creator.socialProfiles) {
      return {
        uuid: generateUuid(),
        name: creator.name,
        socialProfiles: creator.socialProfiles,
        rank: null,
        displayName: isFacebookNumericName ? creator?.displayName : null,
      };
    }

    return {
      uuid: generateUuid(),
      name: creator,
      rank: null,
      displayName: isFacebookNumericName ? creator?.displayName : null,
    };
  });

const selectedCreatorsPayload = (
  selectedInfluencersUrls,
  searchAudienceResult,
) => {
  let previousRank = "a";

  const selectedInfluencersWithSocialProfiles =
    generateSelectedInfluencersWithSocialProfiles(
      selectedInfluencersUrls,
      searchAudienceResult,
    );

  return selectedInfluencersWithSocialProfiles.map((influencer) => {
    const newRank = generateRankString(previousRank, "");
    previousRank = newRank;

    if (typeof influencer === "string") {
      return {
        uuid: generateUuid(),
        name: influencer,
        rank: newRank,
      };
    }
    return {
      uuid: generateUuid(),
      ...influencer,
      rank: newRank,
    };
  });
};

export {
  generateSelectedInfluencersWithSocialProfiles,
  selectedCreatorsPayload,
  generateSocialProfiles,
  generateSelectedInfluencersPayload,
};
